import { SVGProps, Ref, forwardRef } from 'react';

export const MoonStarOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.17 1.916c3.941-2.174 2.378-.184 1.92 2.882l-.038.284c-.714 5.937 4.177 10.72 10.15 9.828 3.065-.458 5.055-2.022 2.882 1.918l-.19.332c-2.01 3.406-5.543 5.84-9.771 5.84-5.951 0-10.81-4.674-11.108-10.55L1 11.876C1 7.513 3.593 3.89 7.17 1.916m.258 1.94C4.658 5.618 2.8 8.517 2.8 11.875a9.324 9.324 0 0 0 9.323 9.324c3.36 0 6.256-1.86 8.02-4.629a15 15 0 0 1-.675.12C12.205 17.774 6.223 11.795 7.31 4.531q.052-.349.118-.677"
                fill="currentColor"
            />
        </g>
    </svg>
));
MoonStarOutlinedSize24Glyph.displayName = 'MoonStarOutlinedSize24Glyph';
